import { Box, Flex } from '@atlaskit/primitives';
import React from 'react';

export interface AskRovoIconProps {
  height?: number;
  width?: number;
  noPadding?: boolean;
}

export const AskRovoIcon: React.FC<AskRovoIconProps> = ({
  height = 12,
  width = 12,
  noPadding = false
}) => (
  <Box padding={noPadding ? 'space.0' : 'space.050'}>
    <Flex>
      <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5299 10.4476L2.73437 13.2163L1.77918 12.6651C1.21823 12.3417 0.871094 11.7418 0.871094 11.0954V4.91065C0.871094 4.26171 1.2162 3.66436 1.77881 3.34113L5.80781 1.0166C5.79888 1.04169 5.79036 1.06695 5.78227 1.09236C5.70768 1.3238 5.66815 1.56833 5.66815 1.81827V8.00303C5.66815 8.85259 6.12069 9.63627 6.85817 10.0601L7.5299 10.4476Z"
          fill="#1868DB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.52991 10.4473L2.73438 13.216L7.13899 15.7572C7.6899 16.0748 8.36786 16.0804 8.92326 15.7741C8.93332 15.7663 8.94403 15.7591 8.95536 15.7525C9.35113 15.5244 9.64055 15.1585 9.77663 14.7358C9.83202 14.5611 9.86129 14.3765 9.86129 14.1875V11.7918L7.52991 10.4473Z"
          fill="#6A9A23"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.319 3.33493L13.2916 2.74219L8.49609 5.5109L9.24029 5.94007C9.97789 6.36392 10.4301 7.14744 10.4301 7.99708V14.1818C10.4301 14.4321 10.3905 14.677 10.3157 14.9087C10.3077 14.9338 10.2993 14.9587 10.2905 14.9835L14.3195 12.659C14.8821 12.3358 15.2272 11.7384 15.2272 11.0895V4.90471C15.2272 4.25833 14.88 3.65833 14.319 3.33493Z"
          fill="#AF59E1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.49356 5.51082L6.23438 4.20796V1.81225C6.23438 1.62347 6.26358 1.43906 6.31885 1.26449C6.45471 0.841993 6.74369 0.476235 7.13903 0.247911L7.14023 0.247219C7.15156 0.240681 7.16234 0.233429 7.1724 0.225631C7.72783 -0.0807372 8.40575 -0.0751089 8.95668 0.242516L13.2891 2.74211L8.49356 5.51082Z"
          fill="#FCA700"
        />
      </svg>
    </Flex>
  </Box>
);
